var map = {
	"./ShiftPredict-illustration": 60,
	"./ShiftPredict-illustration.png": 60,
	"./SmartInsights-illustration": 61,
	"./SmartInsights-illustration.png": 61,
	"./icons/check-gray": 62,
	"./icons/check-gray.svg": 62,
	"./icons/check-white": 63,
	"./icons/check-white.svg": 63,
	"./icons/connect": 101,
	"./icons/connect.svg": 101,
	"./icons/makeshift-logo": 102,
	"./icons/makeshift-logo.svg": 102,
	"./icons/modal-close": 64,
	"./icons/modal-close.svg": 64,
	"./icons/onboarding": 103,
	"./icons/onboarding.svg": 103,
	"./icons/plus-gray": 65,
	"./icons/plus-gray.svg": 65,
	"./icons/plus-white": 66,
	"./icons/plus-white.svg": 66,
	"./icons/scheduling": 104,
	"./icons/scheduling.svg": 104,
	"./icons/spinner": 67,
	"./icons/spinner-gray": 68,
	"./icons/spinner-gray.svg": 68,
	"./icons/spinner-white": 69,
	"./icons/spinner-white.svg": 69,
	"./icons/spinner.svg": 67,
	"./icons/time-attendance": 105,
	"./icons/time-attendance.svg": 105
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 181;